import { render, staticRenderFns } from "./ImageForm.vue?vue&type=template&id=6b382c0a&"
import script from "./ImageForm.vue?vue&type=script&lang=js&"
export * from "./ImageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports